import type { ReactNode } from 'react';

/** 下拉选择 - 展示文本类型 */
export type DisplayTextType =
  | 'tag'
  | 'text'
  | 'displayText'
  | 'customText'
  | 'autoComplete';
export enum DisplayTextEnum {
  TAG = 'tag',
  TEXT = 'text',
  DISPLAY_TEXT = 'displayText',
  CUSTOM_TEXT = 'customText',
  AUTO_COMPLETE = 'autoComplete',
  SELECT = 'select',
  DRAG_SELECT = 'drag-select',
  SELECT_NUM = 'select-num',
}

export type SelectAndUpdateRightTypes = 'content' | 'action';
export enum SelectAndUpdateRight {
  /** 内容 */
  CONTENT = 'content',
  /** 操作 */
  ACTION = 'action',
}

// Select 及 新增修改 - 下拉项类型
export type optsTypes = {
  /** 选项值 */
  value: string;
  /** 选项显示的内容 */
  text: string | ReactNode;
  /** 选项值 */
  id?: string;
  /** 选项显示的内容 */
  content?: string | ReactNode;
  /** 下拉项右侧渲染内容类型 */
  rightType?: SelectAndUpdateRight;
  /** 标识list不转换至编辑状态 */
  unChangeEditStatus?: any;
  /** 其余字段 */
  [key: string]: any;
};

/** 基础版 - 下拉参数 */
export type SelectBseProps = {
  /** 禁用 */
  disabled?: boolean;
  /** 是否支持清空 */
  clearable?: boolean;
  /** 支持搜索 */
  searchable?: boolean;
  /** 当前值 */
  value?: string | number | string[] | number[];
  /** placeholder */
  placeholder?: string | ReactNode;
  /** 默认值 */
  defaultValue?: string | number | string[] | number[];
  /** 表示全选的选项 */
  allOption?: false | optsTypes[];
};
